import React from "react";

export const SectionTitle = ({ children }) => (
  <h3 className="text-sky-900 font-bold text-lg mb-2">{children}</h3>
);

export const UploadTile = ({ label, multiple }) => (
  <label className="rounded-xl border border-slate-200 p-4 grid place-items-center text-center h-32 cursor-pointer hover:border-sky-300">
    <input type="file" className="hidden" multiple={multiple} />
    <div>
      <div className="text-2xl">☁️</div>
      <div className="text-sm text-slate-700">{label}</div>
      <div className="mt-2 inline-block text-xs px-3 py-1 rounded-lg bg-sky-50 text-sky-700 border border-sky-200">
        {multiple ? "Select Files" : "Select File"}
      </div>
    </div>
  </label>
);

export const InputCss = () => (
  <style>{`.input{border:1px solid rgb(226 232 240);border-radius:.75rem;padding:.625rem .75rem;}`}</style>
);
